/*
 * Copyright (C) 2019 Frontier Developments PLC.
 */

import {GetterTree} from 'vuex';
import {RootState} from '@/store/types';
import {SearchCustomerSupportInterface, SearchIssueInterface, SearchStateInterface} from '@/store/modules/search/types';
import {IssueInterface} from '@/store/modules/issues/types';

export const getters: GetterTree<SearchStateInterface, RootState> = {

    /**
     * Get the searched issues.
     *
     * @param {SearchStateInterface} state
     *
     * @returns {SearchIssueInterface}
     */
    getSearchResults(state: SearchStateInterface): SearchIssueInterface {
      return state.searchIssue;
  },

    /**
     * Get the searched customer support answers.
     *
     * @param {SearchStateInterface} state
     *
     * @returns {SearchCustomerSupportInterface}
     */
    getCustomerSupport(state: SearchStateInterface): SearchCustomerSupportInterface {
      return state.searchCustomerSupport;
  },

    /**
     * Get the total results number.
     *
     * @param {SearchStateInterface} state
     *
     * @returns {number}
     */
    getTotalResults(state: SearchStateInterface): number {
      return state.searchIssue.totalResults;
  },

    /**
     * Get the pagination.
     *
     * @param {SearchStateInterface} state
     *
     * @returns {any}
     */
    getPagination(state: SearchStateInterface): number {
      return state.searchIssue.pagination;
  },



};
